import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function isSplit(pin) {
  return Math.floor(pin / 1024) === 1;
}

export function getPlayerId({ lane, teamName, playerNumber, playerName }) {
  return `${lane}-${teamName}-${playerNumber}-${playerName}`;
}
